import './CategorySection.css';

const CategorySection = () => {
  const categories = [
    {
      title: 'Douche & Bad',
      image: '/media/images/Douche-Bad.png',
      link: '/webshop/category/douche-bad'
    },
    {
      title: 'Interieurbeglazing',
      image: '/media/images/Interieurbeglazing.png',
      link: '/webshop/category/interieurbeglazing'
    },
    {
      title: 'Glasartikelen',
      image: '/media/images/Glasartikelen.png',
      link: '/webshop/category/glasartikelen'
    },
    {
      title: 'Balustrade',
      image: '/media/images/Balustrade.png',
      link: '/webshop/category/balustrade'
    },
    {
      title: 'Ventilatieroosters',
      image: '/media/images/Ventilatieroosters.png',
      link: '/webshop/category/ventilatieroosters'
    },
    {
      title: 'Voorzetramen',
      image: '/media/images/Voorzetramen.png',
      link: '/webshop/category/glasartikelen/voorzetramen'
    }
  ];

  return (
    <section className="basic-section category-section">
      <div className="container">
        <div className="category-section__header">
          <div className="sub-text">Direct naar productgroep</div>
          <h2 className="h2">Onze productcategorieën</h2>
          <p className="paragraph category-section__intro">
            Ontdek ons complete assortiment glas, glasbeslag en beglazingsmaterialen.
            Kies een categorie om direct de producten te bekijken.
          </p>
        </div>
        <div className="w-layout-grid category-grid">
          {categories.map((category, index) => (
            <a
              key={index}
              href={category.link}
              className="category-card w-inline-block"
            >
              <img
                src={category.image}
                loading="lazy"
                alt={category.title}
                className="image-8"
              />
              <h3 className="h3 white">{category.title}</h3>
              <div className="div-block-245 white">
                <div className="arrow-button-icon">
                  <img
                    src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/688a372222a18e70b5c0f95d_keyboard_arrow_right_24dp_000000_FILL0_wght400_GRAD0_opsz24%20(3).svg"
                    loading="lazy"
                    alt="Arrow"
                    className="image-7"
                  />
                </div>
                <div>Bekijk producten</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
